<template>
  <figure @click="$emit('click')" :class="[baseCss, 'block', 'select-none', 'relative']" v-aspect-ratio="aspectRatio">
    <div :style="ambienceCss" :class="['absolute', 'w-full', 'h-full', roundness, 'overflow-hidden']" />
    <div :style="imageCss" :class="['relative', roundness, 'overflow-hidden']" />
  </figure>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'AmbientImage',
  mixins: [
    methods
  ],
  data () {
    return {
      boxShadowPositive: 'rgba(0, 0, 0, 0.24) 0px 5px 15px -8px, rgba(0, 0, 0, 0.2) 0px 8px 10px -5px',
      boxShadowNegative: 'rgba(0, 0, 0, 0.24) 0px -5px 15px -8px, rgba(0, 0, 0, 0.2) 0px -8px 10px -5px',
      baseCss: this.componentBaseCss('ambient-image', [])
    }
  },
  computed: {
    roundness () {
      return `rounded-${this.rounded}`
    },
    imageCss () {
      return {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        aspectRatio: this.aspectRatio,
        backgroundImage: `url("${this.src}")`,
        boxShadow: this.direction === 'positive' ? this.boxShadowPositive : this.boxShadowNegative
      }
    },
    ambienceCss () {
      const direction = this.direction
      let offset = this.spread
      let top = 0
      let left = 0
      switch (direction) {
        case 'center':
          offset = offset * 2
          top = `${offset / 2 * -1}px`
          left = `${offset / 2 * -1}px`
          break
        case 'negative':
          top = `${offset * -1}px`
          left = `${offset * -1}px`
          break
        case 'positive':
          top = `${offset}px`
          left = `${offset}px`
      }
      return {
        top,
        left,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        aspectRatio: this.aspectRatio,
        width: `calc(100% + ${offset}px)`,
        height: `calc(100% + ${offset}px)`,
        backgroundImage: `url("${this.src}")`,
        filter: `blur(${this.ambience}px) opacity(${this.opacity})`
      }
    }
  },
  props: {
    src: {
      type: String,
      required: true
    },
    aspectRatio: {
      type: String,
      default: '5/3'
    },
    ambience: {
      type: Number,
      default: 14
    },
    rounded: {
      type: String,
      default: 'none',
      validator: value => {
        return ['none', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', 'full'].includes(value)
      }
    },
    direction: {
      type: String,
      default: 'center',
      validator: value => {
        return ['negative', 'positive', 'center'].includes(value)
      }
    },
    spread: {
      type: Number,
      default: 14
    },
    opacity: {
      type: Number,
      default: 0.9
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/ambient-image/ambient-image.vue